import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Subject, interval, map, switchMap, takeUntil } from 'rxjs';
import { filterDefined } from '../../functions/rxjs-pipes/filter-defined';
import { BackendBoardsService } from '../../services/backend/backend-boards.service';
import { routerEffectsActions } from '../router/router.actions';
import { migrationStatusActions } from './migration-status.actions';

export const loadMigrationStatusEffect = createEffect(
  (actions$ = inject(Actions), backendBoardsService = inject(BackendBoardsService)) => {
    return actions$.pipe(
      ofType(routerEffectsActions.routeBoardIdChanged),
      map(({ boardId }) => boardId),
      filterDefined,
      switchMap((boardId) => {
        return backendBoardsService.getBoardMigrationStatus(boardId).pipe(
          map((migrationStatus) => {
            if (migrationStatus.inProgress) {
              return migrationStatusActions.reloadMigrationStatus({ boardId });
            }
            return migrationStatusActions.loadedMigrationStatus({ boardId, migrationStatus });
          })
        );
      })
    );
  },
  { functional: true }
);

export const loadMigrationStatusWithoutParamsEffect = createEffect(
  (actions$ = inject(Actions), backendBoardsService = inject(BackendBoardsService)) => {
    return actions$.pipe(
      ofType(migrationStatusActions.loadedMigrationStatusWithoutParams),
      map(({ boardId }) => boardId),
      filterDefined,
      switchMap((boardId) => {
        return backendBoardsService.getBoardMigrationStatus(boardId).pipe(
          map((migrationStatus) => {
            if (migrationStatus.inProgress) {
              return migrationStatusActions.reloadMigrationStatus({ boardId });
            }
            return migrationStatusActions.loadedMigrationStatus({ boardId, migrationStatus });
          })
        );
      })
    );
  },
  { functional: true }
);

export const reloadMigrationStatusEffect = createEffect(
  (actions$ = inject(Actions), backendBoardsService = inject(BackendBoardsService)) => {
    const isMigrationDone$ = new Subject<void>();
    return actions$.pipe(
      ofType(migrationStatusActions.reloadMigrationStatus),
      switchMap(({ boardId }) => {
        return interval(30000).pipe(
          takeUntil(isMigrationDone$),
          switchMap(() => {
            return backendBoardsService.getBoardMigrationStatus(boardId).pipe(
              map((migrationStatus) => {
                if (!migrationStatus.inProgress) {
                  isMigrationDone$.next();
                  isMigrationDone$.complete();
                }
                return migrationStatusActions.loadedMigrationStatus({ boardId, migrationStatus });
              })
            );
          })
        );
      })
    );
  },
  { functional: true }
);
